module.exports = __webpack_public_path__ + "img/solution6.7506ebe1.png";